import * as React from 'react';
import { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Checkbox, IconButton, Menu, MenuItem, Box } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import FileDownloadDoneIcon from '@mui/icons-material/FileDownloadDone';
import { useDispatch, useSelector } from 'react-redux';
import { FormProvider, useForm,  } from 'react-hook-form';
import CreatePolicy from '../SidebarLayout/AllAccounts/CreatePolicy';
import { getAllPolicyAction } from '../../redux/actions/policyActions';




const tableHeaders = [
  { id: 'f', label: 'F' },
  { id: 'dl', label: 'DL' },
  { id: 'action', label: 'Action' },
  { id: 'id', label: 'ID Card' },
  { id: 'company', label: 'Company' },
  { id: 'status', label: 'Status' },
  { id: 'type', label: 'Type' },
  { id: 'class', label: 'Class' },
  { id: 'policynumber', label: 'Policy' },
  { id: 'paymentdueday', label: 'Due' },
  { id: 'effectivedate', label: 'Eff Date' },
  { id: 'expirationdate', label: 'Exp/Can Date' },
  { id: 'premium', label: 'Premium' },
  { id: 'edit', label: 'Edit' },
  { id: 'delete', label: 'Delete' },
  { id: 'details', label: 'Details' },
  { id: 'add', label: 'Add' },
  { id: 'rater', label: 'Rater' },
  { id: 'changeowner', label: 'Change Status' }
];

const DropdownButton = ({ label, options }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
      setAnchorEl(null);
  };

  return (
      <div>
          <Button variant="outlined"  endIcon={<ArrowDropDownIcon />} onClick={handleClick}>
              {label}
          </Button>
          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
              {options.map((option, index) => (
                  <MenuItem key={index} onClick={handleClose}>
                      {option}
                  </MenuItem>
              ))}
          </Menu>
      </div>
  );
};

const PoliciesList = () => {
  const [showButton,setShowButton]=useState(false);
  const [showHidePolicy, setShowHidePolicy] = useState(false);
  const [tableData, setTableData] = useState([]);
  const methods = useForm();
  const dispatch = useDispatch();
  const policyData = useSelector((state) => state.policy.customizedForm);
  const allPolicies = useSelector((state) => state.policy.allPolicies);

 useEffect(() => {
      dispatch(getAllPolicyAction());
  }, [dispatch]);

  useEffect(() => {
      if (allPolicies.length > 0) {
          setTableData(allPolicies);
      }
  }, [allPolicies]);

  useEffect(() => {
      if (policyData && Object.keys(policyData).length > 0) {
          setTableData((prevData) => [...prevData, policyData]);
      }
  }, [policyData]);

  const handleEditClick = (task) => {
    setShowHidePolicy(true)
    setShowButton(false);
    methods.reset(task);
  };

  function handleClick() {
    setShowHidePolicy(true);
    setShowButton(true);
  }

  return (
    <>
     {showHidePolicy ? (
        <>
         <FormProvider {...methods}>
            <CreatePolicy setShowHidePolicy={setShowHidePolicy} setShowButton={showButton} />
         </FormProvider>
        </>
      ):(
    <>

    <Box sx={{display:'flex', justifyContent: 'end'}}>
        <Button sx={{ margin: 2 }} onClick={handleClick} variant="contained" color="primary">Add New Policy</Button>
    </Box>
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        {tableHeaders.map(header => (
                            <TableCell sx={{color: '#0173BC', fontWeight: 'bold'}} key={header.id}>{header.label}</TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {tableData.map((row, index) => (
                        <TableRow key={index}>
                            {tableHeaders.map(header => (
                                <TableCell key={header.id} sx={{padding: '12px'}}>
                                    {header.id === 'f' ? (
                                        <Checkbox />
                                    ): header.id === 'edit' ? (
                                        <IconButton onClick={handleEditClick}>
                                            <EditIcon />
                                        </IconButton>
                                        ): header.id === 'delete' ? (
                                        <IconButton >
                                            <DeleteIcon />
                                        </IconButton>
                                        ): header.id === 'dl' ? (
                                        <IconButton>
                                            <FileDownloadDoneIcon />
                                        </IconButton>
                                    ) : header.id === 'action' ? (
                                        <DropdownButton label="Action" options={['Option 1', 'Option 2', 'Option 3']} />
                                    ) : header.id === 'details' ? (
                                        <DropdownButton label="Details" options={['Detail 1', 'Detail 2', 'Detail 3']} />
                                    ) : header.id === 'add' ? (
                                        <DropdownButton label="Add" options={['Add 1', 'Add 2', 'Add 3']} />
                                    ) : header.id === 'rater' ? (
                                        <DropdownButton label="Rater" options={['Rater 1', 'Rater 2', 'Rater 3']} />
                                    ) : (
                                        row[header.id]
                                    )}
                            </TableCell>
                        ))}
                    </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
        </>
      )}
    </>
  );
}

export default PoliciesList;
